import { render, staticRenderFns } from "./L04ArrowFunctions.vue?vue&type=template&id=57c6b99c&"
import script from "./L04ArrowFunctions.vue?vue&type=script&lang=js&"
export * from "./L04ArrowFunctions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports